<template>
	<core-layout-content medium>
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("create_participant") }}</template>
		</core-layout-headline-and-actions>

		<!-- Body -->
		<j-card class="xs-12 bg5 r2 p4">
			<create-update-form @input="handleSubmit">
				<div
					class="flex xs-12 xs-between mt6"
					slot="actions"
					slot-scope="{ onSubmit }"
				>
					<j-button :isLoading="isLoading" @click="onSubmit">
						{{ $t("create_participant") }}
					</j-button>
					<j-button
						type="bordered"
						@click="$router.push({ name: 'InternalsList' })"
					>
						{{ $t("cancel") }}
					</j-button>
				</div>
			</create-update-form>
		</j-card>
	</core-layout-content>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JCard from "@/components/JCard/"
import JButton from "@/components/JButton/"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import CreateUpdateForm from "../components/CreateUpdateForm"
import api from "../api/"

export default {
	components: {
		CoreFormInput,
		JCard,
		JButton,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CreateUpdateForm
	},

	data: () => ({
		isLoading: false
	}),

	methods: {
		async handleSubmit(payload) {
			this.isLoading = true
			// If internalCode === "" or null remove it
			// so that backend can generate code automatically
			if (payload.internalCode === null || payload.internalCode.trim() === "")
				delete payload.internalCode

			// Save email and remove it from payload
			const emailObject = { value: payload.email, id: payload.emailId }
			delete payload.email
			delete payload.emailId

			// Create internal
			const res = await api.createInternal({
				createInternalInput: { ...payload }
			})

			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isLoading = false
				return
			}

			// Add email but only if email was added
			if (!emailObject.value) this.redirectToList()
			console.log(email)

			const res2 = await api.addContact({
				entityId: res?.data?.createInternal?.createdStatus?.id,
				contactInput: { type: "email", value: emailObject.value }
			})

			if (res2.errors) {
				this.$store.dispatch("showError", res.errors)
				this.isLoading = false
				return
			}

			this.isLoading = false
			this.redirectToList()
		},

		redirectToList() {
			this.$router.push({
				name: "InternalsList"
			})
		}
	}
}
</script>
